import React from "react";
import ArchivedMatchesContent from "../components/flightLegs/archived-matches-content";

const ArchivedMatches = () => {
  return <ArchivedMatchesContent />;
};

export default ArchivedMatches;
